// CustomTable.js
import React from "react"
import { DataGrid } from "@mui/x-data-grid"
import { PaginationGrid } from "../PaginationGrid"
import { styles } from "./styles"

const CustomTable = ({
  data,
  height,
  disableSelectionOnClick = true,
  style = {},
  pagination = {
    pageSize: 10,
    totalItems: 400,
    rowsPerPageOptions: [10, 25, 50],
    onPageChange: () => null,
    currentPage: 1,
    totalPages: 0,
  },
  ...otherProps
}) => {
  return (
    <div style={{ height, width: "100%", ...style }}>
      <DataGrid
        rows={data.rows}
        columns={data.columns}
        pageSize={pagination.pageSize}
        loading={false}
        columnHeaderHeight={40}
        rowHeight={40}
        hideFooter
        sx={styles}
        {...otherProps}
      />

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <PaginationGrid
          currentPage={pagination.currentPage}
          onPageChange={pagination.onPageChange}
          totalPages={pagination.totalPages}
        />
      </div>
    </div>
  )
}

export default CustomTable
